<template>
    <div class="newUisetting">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <!-- 标题 -->
                <span class="font-sz24">施工过程文件管理</span>
                <div class="head-text fr-mat-top-4">
                    <el-input v-model="keyworld" style="width: 200px;margin-right: 15px;" placeholder="请输入名称搜索"
                        suffix-icon="el-icon-search" @input="getDataList()">
                    </el-input>
                    <el-button type="primary" @click="addauthority">人员权限设置</el-button>
                    <el-button type="primary" @click="exportExcel">下载</el-button>
                    <el-button type="danger" @click="deleteinfos">删除</el-button>
                </div>
            </div>
            <el-container>
                <!-- 这里是侧边栏-->
                <div class="mar-top20">
                    <el-popconfirm confirm-button-text="好的" cancel-button-text="取消" icon="el-icon-info"
                        icon-color="blue" title="一键验收会将所有资料下载到本地，确定下载吗？" @confirm="generateProject">
                        <el-button style="width: 100%;" slot="reference" type="primary"
                            size="small">一键生成验收资料</el-button>
                    </el-popconfirm>
                    <el-aside width="200px" style="height: 600px;overflow:auto">
                        <zTreeYX :zNodes="zNodes" :isOperational="true"
                            @getData="(ids) => { treeids = ids; getDataList() }" @addZtree="addZtree"
                            @delZtree="delZtree" @EditName="EditName" @addFileZtree="addFileZtree" :options="{
                                id: 'id',
                                pid: 'parentid',
                                label: 'tname',
                                zTreeId: 'PdeptTree',
                                delType: {
                                    add: true,
                                    update: 'is',
                                    del: true,
                                    addFile: true,
                                },
                            }" ref="zTree" />
                    </el-aside>
                </div>
                <el-main>
                    <div class="rygl-table">
                        <el-table align="center" class="margin-20 table width100" v-loading="loading" :data="inform"
                            height="70vh" @selection-change="handleSelectionChange2">
                            <el-table-column align="center" type="selection" width="55"></el-table-column>
                            <el-table-column align="center" type="index" label="序号"></el-table-column>
                            <el-table-column align="center" prop="fname" label="文件名称" sortable>
                                <template slot-scope="scope">
                                    <el-tooltip class="item" :disabled="scope.row.fname.length > 30 ? false : true"
                                        effect="dark" :content="scope.row.fname" placement="top-start">
                                        <el-button size="small" type="text" @click="lookImage(scope.row.fpath)">{{
                                            scope.row.fname.length > 30 ? scope.row.fname.substr(0, 30) :
                                                scope.row.fname
                                        }}</el-button>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" prop="username" label="更新人"></el-table-column>
                            <!-- <el-table-column align="center" prop="createtime" label="更新时间"></el-table-column> -->
                            <el-table-column align="center" label="操作" width="250">
                                <template slot-scope="scope">
                                    <el-button size="small" :type="scope.row.istop != 0 ? 'danger' : 'primary'" plain
                                        @click="TopOne(scope.row.id)">{{ scope.row.istop != 0 ? '取消置顶' : '置顶'
                                        }}</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <el-pagination class="mar-top20" align="right" @size-change="handleSizeChange"
                        @current-change="handleCurrentChange" :current-page="pagenum" :page-sizes="[10, 50, 100]"
                        :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper"
                        :total="total"></el-pagination>
                </el-main>
            </el-container>
            <!-- 预览 -->
            <LookIframe ref="iframebaseRef"></LookIframe>
            <!-- 权限设定 -->
            <el-dialog :close-on-click-modal="false" title="权限设定" :visible.sync="invitation" width="50%" height="50%">
                <el-form :model="invitationForm" label-width="100px" ref="addForm" style="margin: 40px;">
                    <el-form-item label="上传/删除：">
                        <el-select filterable class="width100" v-model="upOrdelUser" multiple placeholder="请选择人员">
                            <el-option v-for="item in optionsUser" :key="item.user01" :label="item.user04"
                                :value="item.user01"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="下载：" class="mar-top40">
                        <el-select filterable class="width100" v-model="downUser" multiple placeholder="请选择人员">
                            <el-option v-for="item in optionsUser" :key="item.user01" :label="item.user04"
                                :value="item.user01"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <el-row>
                    <el-col :span="2" :offset="22">
                        <el-button type="primary" @click="authorityBtn">确定</el-button>
                    </el-col>
                </el-row>
            </el-dialog>
            <!-- 新增文件 -->
            <el-dialog :close-on-click-modal="false" :title="'新增' + Addtitle" :visible.sync="ADDFileShow" width="50%"
                height="50%" :before-close="handleClose">
                <el-form v-if="titleNum == '1'" :model="processForm" :rules="processRule" ref="Updateform"
                    label-width="230px" class="demo-ruleForm mar-r80 ">
                    <el-form-item label="专项监测名称：" prop="val1">
                        <el-select v-model="processForm.val1" placeholder="请选择" class="width100">
                            <el-option v-for="item in specialOption" :key="item.value" :label="item.label"
                                :value="item.label">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="楼栋号：" prop="val2">
                        <el-input v-model="processForm.val2" placeholder="必填，文本，手动输入"></el-input>
                    </el-form-item>
                    <el-form-item label="文件" prop="fileList" ref="imageFile">
                        <el-upload ref="upload" v-model="processForm.fileList" multiple class="upload-demo"
                            accept=".doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf" :action="actionUrl" :on-change="handleChange"
                            :before-upload="beforeUpload">
                            <el-button size="medium">点击选择文件</el-button>
                        </el-upload>
                    </el-form-item>
                </el-form>
                <el-form v-else-if="titleNum == '2'" :model="processForm" :rules="processRule" ref="Updateform"
                    label-width="180px" class="demo-ruleForm mar-r80">
                    <el-form-item label="设备规格型号：" prop="val1">
                        <el-input v-model="processForm.val1" placeholder="必填，文本，手动输入"></el-input>
                    </el-form-item>
                    <el-form-item label="设备应用户型编号：" prop="val2">
                        <el-input v-model="processForm.val2" placeholder="必填，文本，手动输入"></el-input>
                    </el-form-item>
                    <el-form-item label="APF检测值：" prop="val3">
                        <el-input v-model="processForm.val3" placeholder="必填，文本，手动输入"></el-input>
                    </el-form-item>
                    <el-form-item label="额定值冷量：" prop="val4">
                        <el-input v-model="processForm.val4" placeholder="必填，文本，手动输入"></el-input>
                    </el-form-item>
                    <el-form-item label="文件" prop="fileList" ref="imageFile">
                        <el-upload ref="upload" v-model="processForm.fileList" multiple class="upload-demo"
                            accept=".doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf" :action="actionUrl" :on-change="handleChange"
                            :before-upload="beforeUpload">
                            <el-button size="medium">点击选择文件</el-button>
                        </el-upload>
                    </el-form-item>
                </el-form>
                <el-form v-else-if="titleNum == '3'" :model="processForm" :rules="processRule" ref="Updateform"
                    label-width="180px" class="demo-ruleForm mar-r80">
                    <el-form-item label="设备规格型号：" prop="val1">
                        <el-input v-model="processForm.val1"></el-input>
                    </el-form-item>
                    <el-form-item label="设备应用户型编号：" prop="val2">
                        <el-input v-model="processForm.val2" placeholder="必填，文本，手动输入"></el-input>
                    </el-form-item>
                    <el-form-item label="新风量：" prop="val3">
                        <el-input v-model="processForm.val3" placeholder="必填，文本，手动输入"></el-input>
                    </el-form-item>
                    <el-form-item label="单位风量耗功率：" prop="val4">
                        <el-input v-model="processForm.val4" placeholder="必填，文本，手动输入"></el-input>
                    </el-form-item>
                    <el-form-item label="报告类型" prop="val5">
                        <el-select v-model="processForm.val5" placeholder="请选择" class="width100">
                            <el-option v-for="item in reportOption" :key="item.value" :label="item.label"
                                :value="item.label">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="文件" prop="fileList" ref="imageFile">
                        <el-upload ref="upload" v-model="processForm.fileList" multiple class="upload-demo"
                            accept=".doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf" :action="actionUrl" :on-change="handleChange"
                            :before-upload="beforeUpload">
                            <el-button size="medium">点击选择文件</el-button>
                        </el-upload>
                    </el-form-item>
                </el-form>
                <el-form v-else-if="titleNum == '5'" :model="processForm" :rules="processRule" ref="Updateform"
                    label-width="180px" class="demo-ruleForm mar-r80">
                    <el-form-item label="灯具规格名称：" prop="val1">
                        <el-input v-model="processForm.val1"></el-input>
                    </el-form-item>
                    <el-form-item label="灯具功率：" prop="val2">
                        <el-input v-model="processForm.val2" placeholder="必填，文本，手动输入"></el-input>
                    </el-form-item>
                    <el-form-item label="应用房间名称：" prop="val3">
                        <el-input v-model="processForm.val3" placeholder="必填，文本，手动输入"></el-input>
                    </el-form-item>
                    <el-form-item label="文件" prop="fileList" ref="imageFile">
                        <el-upload ref="upload" v-model="processForm.fileList" multiple class="upload-demo"
                            accept=".doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf" :action="actionUrl" :on-change="handleChange"
                            :before-upload="beforeUpload">
                            <el-button size="medium">点击选择文件</el-button>
                        </el-upload>
                    </el-form-item>
                </el-form>
                <el-form v-else-if="titleNum == '9' || titleNum == '10' || titleNum == '12'" :model="processForm"
                    :rules="processRule" ref="Updateform" label-width="180px" class="demo-ruleForm mar-r80">
                    <el-form-item label="保温材料名称:" prop="val1">
                        <el-input v-model="processForm.val1"></el-input>
                    </el-form-item>
                    <el-form-item label="应用部位：" prop="val2">
                        <el-input v-model="processForm.val2" placeholder="必填，文本，手动输入"></el-input>
                    </el-form-item>
                    <el-form-item label="传热系数检测值" prop="val3">
                        <el-input v-model="processForm.val3" placeholder="必填，文本，手动输入"></el-input>
                    </el-form-item>
                    <el-form-item label="文件" prop="fileList" ref="imageFile">
                        <el-upload ref="upload" v-model="processForm.fileList" multiple class="upload-demo"
                            accept=".doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf" :action="actionUrl" :on-change="handleChange"
                            :before-upload="beforeUpload">
                            <el-button size="medium">点击选择文件</el-button>
                        </el-upload>
                    </el-form-item>
                </el-form>
                <el-form v-else :model="processForm" ref="Updateform" label-width="0px" class="demo-ruleForm mar-r80">
                    <el-form-item ref="imageFile">
                        <el-upload ref="upload" v-model="processForm.fileList" multiple class="upload-demo"
                            accept=".doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf" :action="actionUrl" :on-change="handleChange"
                            :before-upload="beforeUpload">
                            <el-button size="medium">点击选择文件</el-button>
                        </el-upload>
                    </el-form-item>
                </el-form>
                <el-row>
                    <el-col :span="2" :offset="22">
                        <el-button type="primary" @click="submitUpdata('Updateform')">确定</el-button>
                    </el-col>
                </el-row>
            </el-dialog>
        </el-card>
    </div>
</template>

<script>
import zTreeYX from "@//components/zTreeYX.vue";
import LookIframe from "@/components/LookIframe.vue";
import {
    GetMember,
    ChangeProjectDeptOrder,
    GetywproTreeList,
    Insertywprotree,
    Updateywprotree,
    Deleteywprotree,
    AddYwFilesWithTree,
    GetYwFilesList,
    DelYwFilesList,
    SetYwFileTop,
    GetYWProUserAuth,
    AddOrUpdateYWProUserAuth,
    BatchDownload
} from "@/setAxios.js";
import FileSaver from "file-saver";
import { download, downloadMore } from "@/tools/tool";
import XLSX from "xlsx";
export default {
    name: "userManagement",
    data() {
        return {
            actionUrl: this.$store.state.baseUrl,
            Addtitle: '',
            titleNum: '1',
            idTree: null,
            keyworld: "",
            loading: false,
            loading2: null,
            total: 0,
            pagesize: 10,
            pagenum: 1,
            invitation: false,
            inform: [],
            addForm: {},
            addprocessForm: {},
            processForm: {
                val1: "",
                val2: "",
                val3: "",
                val4: "",
                val5: "",
                fileList: [],
            },
            processRule: {
                val1: [
                    { required: true, message: '请输入', trigger: 'change' },
                ],
                val2: [
                    { required: true, message: '请输入', trigger: 'blur' },
                ],
                val3: [
                    { required: true, message: '请输入', trigger: 'blur' },
                ],
                val4: [
                    { required: true, message: '请输入', trigger: 'blur' },
                ],
                val5: [
                    { required: true, message: '请输入', trigger: 'blur' },
                ],
                fileList: [
                    {
                        validator: (rule, value, callback) => {
                            const valid = value.length > 0
                            if (valid) {
                                return callback()
                            } else {
                                return callback(new Error(rule.message))
                            }
                        }, required: true, message: '请上传文件',
                    }
                ],
            },
            fileList: [],
            specialOption: [{
                value: '1',
                label: '室内温湿度监测'
            }, {
                value: '2',
                label: '新风量检测'
            }, {
                value: '3',
                label: '建筑整体气密性检测'
            }, {
                value: '4',
                label: '新风热回收装置性能检测'
            }, {
                value: '5',
                label: '照度及照明功率密度检测'
            }, {
                value: '6',
                label: '围护结构热工缺陷检测'
            }, {
                value: '7',
                label: '围护结构主体部位传热系数检测'
            },],
            reportOption: [{
                value: '1',
                label: '型检报告'
            }, {
                value: '2',
                label: '复验报告'
            },],
            optionsUser: [],
            invitationForm: {
            },
            PersonId: 0,
            upOrdelUser: null,
            downUser: null,
            multipleSelection2: [],
            zNodes: null,
            ADDFileShow: false,
            treeids: null
        };
    },
    components: { zTreeYX, LookIframe },
    methods: {
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    this.$refs.upload.clearFiles();
                    this.processForm = {
                        val1: '',
                        val2: '',
                        val3: '',
                        val4: "",
                        val5: '',
                        fileList: []
                    }
                    done();
                })
                .catch(_ => { });
        },
        // 一键生成验收资料
        async generateProject() {
            this.loading2 = this.$loading({
                lock: true,
                text: '获取数据中...',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let params = {
                xid: this.$store.state.xid,
                type: 3,
            };
            let res = await BatchDownload({ params });
            if (res.Code == 0) {
                this.loading2.close();
                this.$message.error(res.Message);
                return;
            }
            if (res.Data) {
                let lastIndex = res.Data.lastIndexOf("/");
                let name = res.Data.substring(lastIndex + 1).split(".")[0];
                this.downLoad(res.Data, name);
            } else {
                this.$message.warning(res.Message);
                this.loading2.close();
            }
        },
        handleChange(file, fileList) {
            this.$nextTick(() => {//等待照片上传完成，
                this.$refs.imageFile.clearValidate('fileList')
            })
            this.processForm.fileList = fileList;
        },
        beforeUpload(file) {
            var index = file.name.lastIndexOf(".");
            var suffix = file.name.substring(index + 1);
            var suffixs = ["doc", "docx", "pdf", "ppt", "pptx", "xls", "xlsx"];
            if (suffixs.indexOf(suffix) == -1) {
                this.$message({
                    message: "上传文件只能是 word、excel、ppt、pdf格式!",
                    type: "warning",
                });
                return false;
            }
            return true;
        },
        // 高亮
        tableRowClassName({ row, rowIndex }) {
            if (row.comu05 != 1) {
                return 'success-row';
            }
            return '';
        },
        lookImage(fpath) {
            this.$refs.iframebaseRef.LookItemPics(fpath);
        },
        // 获取列表
        getDataList() {
            this.loading = true;
            let params = {
                fname: this.keyworld,
                xid: this.$store.state.xid,
                type: 3,
                treeid: this.treeids,
                pageindex: this.pagenum,
                pageSize: this.pagesize,
            };
            let fd = new FormData();
            for (var key in params) {
                fd.append(key, params[key]);
            }
            GetYwFilesList(fd).then((res) => {
                this.loading = false;
                this.inform = res.Data;
                this.total = res.Count;
            });
        },
        // 树的操作
        dropTree(data) {
            ChangeProjectDeptOrder(data).then((res) => {
                if (res) {
                    this.$message({
                        type: "success",
                        message: "移动成功",
                    });
                }
            });
        },
        async addZtree(id) {
            let params = {
                id: 0,
                projectid: this.$store.state.xid,
                tname: "新建节点" + Math.floor(Math.random() * 100),
                parentid: id,
                orderid: null,
                type: 3,
                createuserid: localStorage.getItem("id"),
            };
            let res = await Insertywprotree(params);
            this.$refs.zTree.add(res);
        },
        async addFileZtree(id, data) {
            this.ADDFileShow = true;
            this.Addtitle = data.tname;
            this.idTree = data.id;
            this.processForm.fileList = []
            switch (data.tname) {
                case '超低能耗专项检测报告':
                    this.titleNum = '1';
                    break;
                case '暖通空调系统文件':
                    this.titleNum = '2';
                    break;
                case '新风系统文件':
                    this.titleNum = '3';
                    break;
                case '照明系统文件':
                    this.titleNum = '5';
                    break;
                case '屋面保温材料检测报告':
                    this.titleNum = '9';
                    break;
                case '围护墙保温材料检测报告':
                    this.titleNum = '10';
                    break;
                case '断热桥措施位置检测报告':
                    this.titleNum = '12';
                    break;
                default:
                    this.titleNum = '20';
                    break;
            }
        },
        async delZtree(ids) {
            if (ids.split(',').length > 1) {
                this.$message({
                    message: "请选择一个节点进行删除",
                    type: "warning",
                });
                return false;
            }
            let params = { id: ids };
            let res = await Deleteywprotree(params);
            this.$refs.zTree.del(res);
        },
        async EditName(id, name, pid, data) {
            let params = {
                id,
                projectid: data.projectid,
                tname: name,
                parentid: data.parentid,
                orderid: data.orderid,
                type: data.type,
                createuserid: data.createuserid
            };
            let res = await Updateywprotree(params);
            this.$message.success("编辑成功");
        },
        // 文件树
        GetywproTree() {
            this.loading = true;
            GetywproTreeList({ params: { xid: this.$store.state.xid, type: 3 } }).then((res) => {
                this.zNodes = res.Data;
                this.loading = false;
            });
        },
        // 添加文件
        submitUpdata(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let fd = new FormData();
                    this.processForm.fileList.forEach((file) => {
                        fd.append(`${file.name}^@^${file.versions}`, file.raw);
                    })
                    fd.append("xid", this.$store.state.xid);
                    fd.append("type", 3);
                    fd.append("targetId", this.idTree);
                    for (var key in this.processForm) {
                        fd.append(key, this.processForm[key]);
                    }
                    AddYwFilesWithTree(fd).then((res) => {
                        if (res.Code != 0) {
                            this.$message.success("上传成功");
                            this.processForm = {
                                val1: '',
                                val2: '',
                                val3: '',
                                val4: "",
                                val5: '',
                                fileList: []
                            }
                            this.ADDFileShow = false;
                            this.$refs.upload.clearFiles();
                            this.getDataList();
                        } else {
                            this.$message.error(res.Message);
                        }
                    })
                } else {
                    this.$message.error('验证失败！')
                    return false;
                }
            });
        },
        // 人员权限设置
        addauthority() {
            this.invitation = true;
            this.GetYWProUserAuthUser()
            let params = {
                seachword: "",
                id: this.$store.state.xid,
                cid: localStorage.getItem("pid"),
                bid: "null",
                pageIndex: 1,
                pageSize: 999999,
            };
            GetMember({ params }).then((res) => {
                this.optionsUser = res.Data.list;
            });
        },
        // 获取项目模块人员权限
        GetYWProUserAuthUser() {
            let params = {
                xid: this.$store.state.xid,
                type: 5
            }
            GetYWProUserAuth({ params }).then((res) => {
                if (res.Data) {
                    this.upOrdelUser = res.Data.insertuids != null ? res.Data.insertuids.split(',').map(Number) : null;
                    this.downUser = res.Data.downloaduids != null ? res.Data.downloaduids.split(',').map(Number) : null;
                    this.PersonId = res.Data.id
                }
            });
        },
        authorityBtn() {
            let params = {
                id: this.PersonId,
                projectid: localStorage.getItem("xid"),
                insertuids: this.upOrdelUser != null ? this.upOrdelUser.join(",") : null,
                downloaduids: this.downUser != null ? this.downUser.join(",") : null,
                replyuids: null,
                type: 5,
                createuserid: localStorage.getItem("id")
            }
            AddOrUpdateYWProUserAuth(params).then((res) => {
                if (res.Code != 0) {
                    this.$message({
                        type: "success",
                        message: "设置成功",
                    });
                    this.invitation = false;
                    this.getDataList();
                }
                else {
                    this.$message({
                        type: "warning",
                        message: "信息有误或未选择",
                    });
                }
            });
        },
        handleSelectionChange2(val) {
            this.multipleSelection2 = val;
        },
        // 导出表格所用
        exportExcel() {
            if (this.multipleSelection2.length < 1) {
                this.$message.warning('请选择要下载的内容')
            } else {
                this.multipleSelection2.forEach((el) => {
                    this.downLoad(el.fpath, el.fname);
                })
            }
        },
        downLoad(path, name) {
            try {
                download(
                    this.$store.state.baseUrl + path,
                    name + path.substr(path.lastIndexOf(".")),
                    this.loading2
                );
            } catch (error) {
                this.$message.error("导出失败");
            }
        },
        //批量删除
        deleteinfos() {
            if (this.multipleSelection2.length == 0) {
                this.$message({
                    type: "warning",
                    message: "请选择删除内容!",
                });
            } else {
                this.$confirm("此操作将移除所选文件, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        let ids = "",
                            _split = "";
                        this.multipleSelection2.forEach((v) => {
                            ids += _split + v.id;
                            _split = ",";
                        });
                        let params = {
                            ids: ids,
                        };
                        DelYwFilesList(params).then((res) => {
                            if (res.Code > 0) {
                                this.$message({
                                    type: "success",
                                    message: "移除成功!",
                                });
                            }
                            this.getDataList();
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消操作",
                        });
                        this.loading = false;
                    });
            }
        },
        //   置顶
        async TopOne(id) {
            let params = { id };
            let res = await SetYwFileTop(params);
            this.getDataList();
        },
        handleSizeChange(val) {
            this.pagesize = val;
            this.getDataList();
        },
        handleCurrentChange(val) {
            this.pagenum = val;
            this.getDataList();
        },
    },
    created() {
        this.getDataList();
    },
    mounted() {
        this.GetywproTree();
    },
};
</script>

<style lang="less" scoped>
div#PdeptRemenu {
    position: fixed;
    visibility: hidden;
    top: 0;
    width: 60px;
    background-color: #35a5db;
    padding: 4px;
    border-radius: 3px;
    overflow: auto;
    border: 1px solid #eee;
}

div#PdeptRemenu ul {
    margin: 0px;
    padding: 0px;
}

div#PdeptRemenu ul li {
    font-size: 12px;
    line-height: 20px;
    margin: 0px;
    padding: 0px;
    cursor: pointer;
    list-style: none outside none; //取消样式
    background-color: rgba(255, 255, 255, 0);
    padding-left: 3px;
    margin: 1px auto;
    color: white;
    border-radius: 3px;
    letter-spacing: 1px;
}

div#PdeptRemenu ul li:hover {
    background: #eee;
    color: #000000;
}

#PdeptTree {
    height: 500px;
}

.zTreeDiv {
    overflow: auto;
}

.ztree li span {
    // color: #fff;
    line-height: 21px;
    margin-right: 2px;
}

.userManagement .search-input {
    width: 300px;
}

/deep/ #UpdateProUserOpen1 .el-input__inner::-webkit-input-placeholder {
    color: #000000;
}
</style>
<style scoped lang="less">
/* 新增 */
.font-sz24 {
    font-size: 24px;
}

.fr-mat-top-4 {
    float: right;
    margin-top: -4px;
}

.mar-t80 {
    margin-right: 80px;
}

.mar-top20 {
    margin-top: 20px;
}

.elAside {
    /* border: 1px solid #dcdfe6; */
    border-radius: 4px;
    text-align: center;
}

.width100 {
    width: 100%;
}

.mar-top40 {
    margin-top: 40px;
}

.mar00-20-30 {
    margin: 0 0 20px 30%;
}

.mar-r80 {
    margin-right: 80px;
}

.txt-cen-pa20-0 {
    text-align: right;
    padding: 20px 0;
}

.width90 {
    width: 90%;
}

.text-cen {
    text-align: center;
}

/deep/.el-table .success-row {
    background: #f0f9eb;
}
</style>